import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

const BannerStatusFilter = ({ onClickFilterCallback }) => {
    const [keyword, setKeyword] = useState('')

    const onKeywordChange = (e) => {
        setKeyword(e.target.value)
    }

    const onClickFilter = (event, reset = false) => {
        event.preventDefault()

        if (reset) {
            setKeyword('')
            onClickFilterCallback('')
        } else {
            onClickFilterCallback(keyword)
        }
    }

    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            <div className="col-md-3">
                <p>Keyword</p>
                <div>
                    <input
                        value={keyword}
                        onChange={onKeywordChange}
                        type="text"
                        placeholder="id, domain name, banner text"
                    />
                </div>
            </div>

            <div className="col-md-3 pl-0">
                <p>&nbsp;</p>
                <div className="flex">
                    <Button
                        type="submit"
                        className="btn btn-sm btn-primary"
                    >
                        Filter
                    </Button>

                    <Button
                        type="button"
                        onClick={(e) => onClickFilter(e, true)}
                        className="btn btn-sm btn-secondary"
                    >
                        Reset
                    </Button>
                </div>
            </div>
        </form>
    )
}

BannerStatusFilter.propTypes = {
    onClickFilterCallback: PropTypes.func.isRequired
}

export default BannerStatusFilter
